/**
 * redux/slices/ui.ts — small UI slice for cross-page widgets.
 *
 * v1: just the auto-refresh toggle for Bank Submission Status. We could
 * persist this to localStorage later if users want it sticky.
 */

import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from '../store';

export interface UiState {
	autoRefreshEnabled: boolean;
}

const INITIAL: UiState = {
	autoRefreshEnabled: false,
};

const uiSlice = createSlice({
	name: 'ui',
	initialState: INITIAL,
	reducers: {
		setAutoRefresh(state, action: PayloadAction<boolean>) {
			state.autoRefreshEnabled = action.payload;
		},
	},
});

export const { setAutoRefresh } = uiSlice.actions;
export default uiSlice.reducer;

export const selectAutoRefresh = (s: RootState): boolean => s.ui.autoRefreshEnabled;
